import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';

// A styled 3-choice prompt used for Edit / Delete / Move / Drag on a
// recurring or multi-day task.
//
// props:
//   open (bool)
//   title (string)
//   description (string)
//   onCancel ()
//   onChoose(scope: 'this'|'future'|'all')
//   language ('el'|'en')

export default function ScopePrompt({ open, title, description, onCancel, onChoose, language = 'el' }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel && onCancel()}>
      <DialogContent className="sm:max-w-[420px] rounded-none" data-testid="scope-prompt">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {description && <p className="text-sm text-zinc-600">{description}</p>}
        <div className="space-y-2 pt-2">
          <Button
            className="w-full justify-start rounded-none"
            variant="outline"
            onClick={() => onChoose('this')}
            data-testid="scope-this"
          >
            {language === 'el' ? 'Μόνο αυτή την εμφάνιση' : 'This occurrence only'}
          </Button>
          <Button
            className="w-full justify-start rounded-none"
            variant="outline"
            onClick={() => onChoose('future')}
            data-testid="scope-future"
          >
            {language === 'el' ? 'Αυτή και μελλοντικές' : 'This and following occurrences'}
          </Button>
          <Button
            className="w-full justify-start rounded-none bg-zinc-900 text-white hover:bg-zinc-800"
            onClick={() => onChoose('all')}
            data-testid="scope-all"
          >
            {language === 'el' ? 'Όλες οι εμφανίσεις (Όλη η σειρά)' : 'All occurrences (entire series)'}
          </Button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} className="rounded-none" data-testid="scope-cancel">
            {language === 'el' ? 'Άκυρο' : 'Cancel'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
